class PerfectPatchesWhyPatches extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.revealed = false;
    this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.handleMotionPreference = this.handleMotionPreference.bind(this);
  }

  connectedCallback() {
    this.motionPreference.addEventListener?.('change', this.handleMotionPreference);
    this.prepare();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.motionPreference.removeEventListener?.('change', this.handleMotionPreference);
  }

  handleMotionPreference() {
    this.observer?.disconnect();

    if (this.motionPreference.matches) {
      this.classList.remove('pp-why-patches--enhanced');
      this.classList.add('is-visible');
      return;
    }

    if (!this.revealed) this.prepare();
  }

  prepare() {
    this.observer?.disconnect();
    if (this.motionPreference.matches || !('IntersectionObserver' in window)) {
      this.classList.remove('pp-why-patches--enhanced');
      this.classList.add('is-visible');
      return;
    }

    this.classList.add('pp-why-patches--enhanced');
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.15) return;
          entry.target.classList.add('is-visible');
          this.observer?.unobserve(entry.target);
        });
        this.revealed = [...this.querySelectorAll('.pp-why-patches__step')]
          .every((step) => step.classList.contains('is-visible'));
      },
      { threshold: 0.15, rootMargin: '0px 0px -64px 0px' }
    );
    this.querySelectorAll('.pp-why-patches__step:not(.is-visible)')
      .forEach((step) => this.observer.observe(step));
  }
}

if (!customElements.get('pp-why-patches')) {
  customElements.define('pp-why-patches', PerfectPatchesWhyPatches);
}
